import { createApp } from 'vue'
import App from './App.vue'

const mountEl = document.querySelector('#project-search-app')

if (mountEl) {
	createApp(App, { data: (mountEl as HTMLElement).dataset }).mount(
		'#project-search-app'
	)
}
